// extracted by mini-css-extract-plugin
export default {"hide-show-button":"hide-show-button_hide-show-button__sz1Ck"};